import BlockSyllabusVM from './block-syllabus-vm';
import Vue from 'vue';

export default {
  init: function(node) {
    const data = JSON.parse(node.dataset.course);
    const enrolled = node.dataset.enrolled == 'true';
    const vm = new Vue(BlockSyllabusVM);
    vm.bindData(data, enrolled);
    vm.$mount(node);
  }
};
